(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compare-card"] && !Shopify.designMode) return;
  try {
    class CompareCard extends HTMLElement {
    connectedCallback() {
      this.#modelId = this.getAttribute('data-model-id');
      this.#selectedProductId = this.getAttribute('data-first-product-id');
      this.#selectedVariantId = this.getAttribute('data-first-variant-id');

      this.#panels = Array.from(this.querySelectorAll('[data-product-panel]'));
      this.#graphicOptions = Array.from(this.querySelectorAll('[data-graphic-option]'));
      this.#lengthSets = Array.from(this.querySelectorAll('[data-length-set]'));
      this.#specGroups = Array.from(this.querySelectorAll('[data-spec-length]'));
      this.#availTexts = Array.from(this.querySelectorAll('[data-variant-avail]'));
      this.#variantInput = this.querySelector('[data-variant-input]');
      this.#cartButton = this.querySelector('[data-cart-button]');
      this.#cartForm = this.querySelector('[data-cart-form]');
      this.#graphicSwatchEl = this.querySelector('[data-graphic-swatch]');
      this.#graphicTextEl = this.querySelector('[data-graphic-text]');

      this.#bindCloseButton();
      this.#bindDropdowns();
      this.#bindGraphicOptions();
      this.#bindLengthOptions();
      this.#bindCartForm();

      this.#boundClickOutside = (e) => this.#handleClickOutside(e);
      this.#boundEscape = (e) => {
        if (e.key === 'Escape') this.#closeAllDropdowns();
      };
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#boundClickOutside);
      document.removeEventListener('keydown', this.#boundEscape);
    }

    #bindCloseButton() {
      var closeBtn = this.querySelector('[data-close-button]');
      if (!closeBtn) return;
      closeBtn.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('compare:close', {
          bubbles: true,
          detail: { modelId: this.#modelId }
        }));
      });
    }

    #bindDropdowns() {
      var toggles = Array.from(this.querySelectorAll('[data-select-toggle]'));
      for (var i = 0; i < toggles.length; i++) {
        (function(toggle) {
          toggle.addEventListener('click', function(e) {
            e.stopPropagation();
            this.#toggleDropdown(toggle);
          }.bind(this));
        }).call(this, toggles[i]);
      }
    }

    #toggleDropdown(toggleBtn) {
      var selectEl = toggleBtn.closest('[data-select]');
      if (!selectEl) return;
      var panel = selectEl.querySelector('[data-select-panel]');
      if (!panel) return;

      var isOpen = !panel.hidden;
      this.#closeAllDropdowns();

      if (!isOpen) {
        panel.hidden = false;
        toggleBtn.setAttribute('aria-expanded', 'true');
        this.#openDropdown = panel;
        document.addEventListener('click', this.#boundClickOutside);
        document.addEventListener('keydown', this.#boundEscape);
      }
    }

    #closeAllDropdowns() {
      var panels = this.querySelectorAll('[data-select-panel]');
      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = true;
      }
      var toggles = this.querySelectorAll('[data-select-toggle]');
      for (var j = 0; j < toggles.length; j++) {
        toggles[j].setAttribute('aria-expanded', 'false');
      }
      this.#openDropdown = null;
      document.removeEventListener('click', this.#boundClickOutside);
      document.removeEventListener('keydown', this.#boundEscape);
    }

    #handleClickOutside(e) {
      if (!this.contains(e.target)) {
        this.#closeAllDropdowns();
        return;
      }
      var inDropdown = e.target.closest('[data-select-panel]') || e.target.closest('[data-select-toggle]');
      if (!inDropdown) {
        this.#closeAllDropdowns();
      }
    }

    #bindGraphicOptions() {
      for (var i = 0; i < this.#graphicOptions.length; i++) {
        (function(option) {
          option.addEventListener('click', function() {
            this.#selectGraphic(option);
          }.bind(this));
        }).call(this, this.#graphicOptions[i]);
      }
    }

    #selectGraphic(option) {
      var productId = option.getAttribute('data-product-id');
      if (!productId || productId === this.#selectedProductId) {
        this.#closeAllDropdowns();
        return;
      }

      this.#selectedProductId = productId;

      for (var i = 0; i < this.#graphicOptions.length; i++) {
        var isMatch = this.#graphicOptions[i].getAttribute('data-product-id') === productId;
        this.#graphicOptions[i].classList.toggle('compare-card__select-option--active', isMatch);
        this.#graphicOptions[i].setAttribute('aria-selected', String(isMatch));
      }

      var swatchUrl = option.getAttribute('data-swatch-url');
      var graphicName = option.getAttribute('data-graphic-name');
      if (this.#graphicSwatchEl && swatchUrl) {
        var img = this.#graphicSwatchEl.querySelector('img');
        if (img) img.src = swatchUrl;
      }
      if (this.#graphicTextEl) {
        this.#graphicTextEl.textContent = graphicName;
      }

      for (var j = 0; j < this.#panels.length; j++) {
        var panelMatch = this.#panels[j].getAttribute('data-product-panel') === productId;
        this.#panels[j].classList.toggle('compare-card--hidden', !panelMatch);
      }

      for (var k = 0; k < this.#lengthSets.length; k++) {
        var setMatch = this.#lengthSets[k].getAttribute('data-length-set') === productId;
        this.#lengthSets[k].classList.toggle('compare-card--hidden', !setMatch);
      }

      var activeSet = null;
      for (var m = 0; m < this.#lengthSets.length; m++) {
        if (this.#lengthSets[m].getAttribute('data-length-set') === productId) {
          activeSet = this.#lengthSets[m];
          break;
        }
      }
      if (activeSet) {
        var firstLengthOption = activeSet.querySelector('[data-length-option][data-variant-available="true"]')
          || activeSet.querySelector('[data-length-option]');
        if (firstLengthOption) {
          this.#selectLength(firstLengthOption, activeSet);
        }
      }

      this.#closeAllDropdowns();
    }

    #bindLengthOptions() {
      var allLengthOptions = this.querySelectorAll('[data-length-option]');
      for (var i = 0; i < allLengthOptions.length; i++) {
        (function(option) {
          option.addEventListener('click', function() {
            var parentSet = option.closest('[data-length-set]');
            this.#selectLength(option, parentSet);
          }.bind(this));
        }).call(this, allLengthOptions[i]);
      }
    }

    #selectLength(option, parentSet) {
      var variantId = option.getAttribute('data-variant-id');
      var isAvailable = option.getAttribute('data-variant-available') === 'true';
      var lengthValue = option.getAttribute('data-length-value');

      this.#selectedVariantId = variantId;

      var siblings = parentSet.querySelectorAll('[data-length-option]');
      for (var i = 0; i < siblings.length; i++) {
        var isMatch = siblings[i] === option;
        siblings[i].classList.toggle('compare-card__select-option--active', isMatch);
        siblings[i].setAttribute('aria-selected', String(isMatch));
      }

      var textEl = parentSet.querySelector('[data-length-text]');
      if (textEl) {
        textEl.textContent = option.textContent.trim().split(' - ')[0];
      }

      if (this.#variantInput) {
        this.#variantInput.value = variantId;
      }

      if (this.#cartButton) {
        this.#cartButton.disabled = !isAvailable;
        this.#cartButton.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
      }

      for (var j = 0; j < this.#availTexts.length; j++) {
        var availMatch = this.#availTexts[j].getAttribute('data-variant-avail') === variantId;
        this.#availTexts[j].classList.toggle('compare-card--hidden', !availMatch);
      }

      for (var k = 0; k < this.#specGroups.length; k++) {
        var specMatch = this.#specGroups[k].getAttribute('data-spec-length') === lengthValue;
        this.#specGroups[k].classList.toggle('compare-card--hidden', !specMatch);
      }

      this.#closeAllDropdowns();
    }

    #bindCartForm() {
      if (!this.#cartForm) return;
      this.#cartForm.addEventListener('submit', function(e) {
        e.preventDefault();
        this.#addToCart();
      }.bind(this));
    }

    #getCartSectionIds() {
      var sectionIds = [];
      var cartComponents = document.querySelectorAll('cart-items-component');
      for (var i = 0; i < cartComponents.length; i++) {
        var sid = cartComponents[i].dataset.sectionId;
        if (sid) sectionIds.push(sid);
      }
      return sectionIds;
    }

    async #addToCart() {
      if (!this.#selectedVariantId || !this.#cartButton) return;
      if (this.#cartButton.disabled) return;

      var originalText = this.#cartButton.textContent;
      this.#cartButton.disabled = true;
      this.#cartButton.textContent = 'Adding...';
      this.#cartButton.classList.add('compare-card__cart-btn--loading');

      try {
        var sectionIds = this.#getCartSectionIds();
        var body = {
          items: [{ id: parseInt(this.#selectedVariantId, 10), quantity: 1 }]
        };
        if (sectionIds.length > 0) {
          body.sections = sectionIds.join(',');
        }

        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        var data = await response.json();

        this.#cartButton.textContent = 'Added!';

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              source: 'compare-card',
              itemCount: 1,
              productId: this.#selectedProductId,
              variantId: this.#selectedVariantId,
              sections: data.sections || {}
            }
          }
        }));

        var btn = this.#cartButton;
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
          btn.classList.remove('compare-card__cart-btn--loading');
        }, 2000);

      } catch (err) {
        this.#cartButton.textContent = 'Error - Try Again';
        var btn2 = this.#cartButton;
        setTimeout(function() {
          btn2.textContent = originalText;
          btn2.disabled = false;
          btn2.classList.remove('compare-card__cart-btn--loading');
        }, 2000);
      }
    }

    #modelId;
    #selectedProductId;
    #selectedVariantId;
    #panels;
    #graphicOptions;
    #lengthSets;
    #specGroups;
    #availTexts;
    #variantInput;
    #cartButton;
    #cartForm;
    #graphicSwatchEl;
    #graphicTextEl;
    #boundClickOutside;
    #boundEscape;
    #openDropdown;
  }

  if (!customElements.get('compare-card')) {
    customElements.define('compare-card', CompareCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ski-model-card"] && !Shopify.designMode) return;
  try {
    class SkiModelCard extends HTMLElement {
    connectedCallback() {
      this.#thumbnails = Array.from(this.querySelectorAll('[data-thumbnail-button]'));
      this.#panels = Array.from(this.querySelectorAll('[data-product-panel]'));
      this.#infos = Array.from(this.querySelectorAll('[data-product-info]'));

      const activePanel = this.#panels.find(
        (p) => !p.classList.contains('custom-model-card__panel--hidden')
      );
      if (activePanel) {
        this.#selectedId = activePanel.getAttribute('data-product-panel');
      }

      for (const btn of this.#thumbnails) {
        btn.addEventListener('click', (e) => this.#onThumbnailClick(e));
        btn.addEventListener('mouseenter', (e) => this.#onThumbnailHover(e));
      }
    }

    #onThumbnailClick(e) {
      const btn = e.currentTarget;
      const id = btn.getAttribute('data-product-id');
      if (!id || btn.getAttribute('data-soldout') === 'true') return;
      this.#selectedId = id;
      this.#switchProduct(id);
    }

    #onThumbnailHover(e) {
      const btn = e.currentTarget;
      const id = btn.getAttribute('data-product-id');
      if (!id) return;
      this.#switchProduct(id);
    }

    #switchProduct(productId) {
      for (const panel of this.#panels) {
        const match = panel.getAttribute('data-product-panel') === productId;
        panel.classList.toggle('custom-model-card__panel--hidden', !match);
      }

      for (const btn of this.#thumbnails) {
        const match = btn.getAttribute('data-product-id') === productId;
        btn.classList.toggle('custom-model-card__thumbnail--active', match);
        btn.setAttribute('aria-selected', String(match));
      }

      for (const info of this.#infos) {
        const match = info.getAttribute('data-product-info') === productId;
        info.classList.toggle('custom-model-card__info--hidden', !match);
      }
    }

    #thumbnails;
    #panels;
    #infos;
    #selectedId;
  }

  if (!customElements.get('ski-model-card')) {
    customElements.define('ski-model-card', SkiModelCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ski-size-calculator-modal"] && !Shopify.designMode) return;
  try {
    class SkiSizeCalculator extends HTMLElement {
    connectedCallback() {
      this.#form = this.querySelector('[ref="calculatorForm"]');
      this.#heightSelect = this.querySelector('[ref="heightSelect"]');
      this.#weightInput = this.querySelector('[ref="weightInput"]');
      this.#skillsSelect = this.querySelector('[ref="skillsSelect"]');
      this.#resultContainer = this.querySelector('[ref="resultContainer"]');
      this.#resultValue = this.querySelector('[ref="resultValue"]');
      this.#resultRange = this.querySelector('[ref="resultRange"]');

      /* Load height options from JSON */
      const dataUrlEl = this.querySelector('[ref="dataUrl"]');
      const dataUrl = dataUrlEl?.textContent?.trim();
      if (dataUrl) {
        fetch(dataUrl)
          .then((r) => r.json())
          .then((data) => {
            this.#populateHeights(data.heightOptions || []);
            this.#restoreFromStorage();
          })
          .catch(() => {});
      }

      this.#form?.addEventListener('submit', (e) => this.#handleSubmit(e));
    }

    #form;
    #heightSelect;
    #weightInput;
    #skillsSelect;
    #resultContainer;
    #resultValue;
    #resultRange;

    #populateHeights(options) {
      if (!this.#heightSelect) return;
      for (const opt of options) {
        const el = document.createElement('option');
        el.value = opt.value;
        el.textContent = opt.label;
        this.#heightSelect.appendChild(el);
      }
    }

    #restoreFromStorage() {
      try {
        const saved = localStorage.getItem('skiprefs');
        if (!saved) return;
        const prefs = JSON.parse(saved);

        if (prefs.height && this.#heightSelect) this.#heightSelect.value = String(prefs.height);
        if (prefs.weight && this.#weightInput) this.#weightInput.value = String(prefs.weight);
        if (prefs.skills !== undefined && this.#skillsSelect) this.#skillsSelect.value = String(prefs.skills);

        if (prefs.recommended) {
          this.#showResult(prefs.recommended);
        }
      } catch { /* noop */ }
    }

    #handleSubmit(e) {
      e.preventDefault();

      const height = parseInt(this.#heightSelect?.value);
      const weight = parseInt(this.#weightInput?.value);
      const skills = parseInt(this.#skillsSelect?.value);

      if (!height || !weight || isNaN(skills)) return;

      /* recommendSize formula */
      let weightMult = 0;
      if (weight < 100) {
        weightMult = Math.round((100 - weight) / 15);
      } else if (weight > 120) {
        weightMult = Math.round((weight - 120) / 15);
      }

      const recommended = weightMult + height + skills;

      /* Save to localStorage */
      try {
        localStorage.setItem('skiprefs', JSON.stringify({
          weight,
          height,
          skills,
          recommended,
        }));
      } catch { /* noop */ }

      this.#showResult(recommended);

      /* Update Klaviyo profile (no-op unless visitor is identified) */
      this.#trackKlaviyo(height, skills, recommended);

      /* Dispatch event for variant picker link to update */
      document.dispatchEvent(new CustomEvent('ski-size-calculated', {
        detail: { recommended },
      }));
    }

    #trackKlaviyo(height, skills, recommended) {
      if (typeof window.klaviyo === 'undefined') return;

      const ability =
        skills === -10 ? 'beginner' : skills === -5 ? 'intermediate' : 'expert';

      window.klaviyo.push([
        'identify',
        {
          preference_height: height,
          preference_ability: ability,
          preference_ski_length: recommended,
        },
      ]);
    }

    #roundToNearest5(n) {
      return Math.round(n / 5) * 5;
    }

    #showResult(recommended) {
      if (!this.#resultContainer || !this.#resultValue || !this.#resultRange) return;
      this.#resultContainer.hidden = false;
      this.#resultValue.textContent = recommended + 'cm';
      this.#resultRange.textContent =
        this.#roundToNearest5(recommended - 5) + ' - ' + this.#roundToNearest5(recommended + 5) + 'cm';
    }
  }

  if (!customElements.get('ski-size-calculator')) {
    customElements.define('ski-size-calculator', SkiSizeCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
